<template>
  <CModal
    class="modal__footer-empty"
    size="lg"
    :close-on-backdrop="false"
    :show="show"
    @update:show="closeModal"
  >
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">{{ title }}</span>
      </div>

      <CButtonClose @click="closeModal"/>
    </template>

    <div class="subflow">
      <VTable
    :items="computedFields"
    :fields="fields"
    :loading="loading"
    :on-edit-item="onEditItem"
    :on-input-edit="onInputEdit"
    :on-delete-item="onDeleteItem"
    :on-edit-close="onEditClose"
    :on-edit-submit="onEditSubmit"
    searchPlaceholder="Search for dealer...."
    hideAddButton
    :hideSearchBar="true"
    hover
    striped
    border
    small
    fixed
    dark
  >
    <!-- <template #footer>
      <VPagination
        :items-count="selectedCar.comments.length"
        class="user-manager-card__footer-pagination"
      />
    </template> -->
  </VTable>
    </div>
  </CModal>
</template>
<script>
import VCarForm from "@/components/Forms/VCarForm";
import { modalStore } from "@/mixins/modalsMixin";
import ModalType from "@/utils/dictionaries/modalType";
import api from "@/api/api";
import _ from 'lodash'
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
import {
  createCommentsStoreMixin,
  commentsStore
} from "@/mixins/commentsMixin";
export default {
  name: "TheCommentsModal",
  mixins: [createAuctionManagerMixin(), createCommentsStoreMixin()],
  components: {
    // VCarForm
  },
  data: () => {
    return {
      loading: true,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  mounted(){
    this.$store.dispatch(`${modalStore.moduleName}/${modalStore.actionTypes.ACTION_INIT_WS}`)

  },
  watch:{
    selectedCar(v){
      console.log("selectedCar v",v) 
      this[auctionManagerStore.actionTypes.ACTION_COMMENTS]({ carId: v.id, type: v.type })
    },
    'selectedCar.isLoading': {
    handler(newValue) {
      console.log("selectedCar.isLoading", newValue)
      if (newValue != undefined) {
        this.loading = false;
      }
    },
    immediate: true, // Trigger the watcher immediately if the value exists
  },
  },
  computed: {
    fields() {
      return [
        {
          key: "sender",
          label: "Sender",
          _style: "min-width: 200px",
          _classes: "sender"
        },
        {
          key: "comment",
          label: "Comment",
          _style: "min-width: 200px",
          _classes: "comment"
        },
        
        { key: "action", _style: "max-width: 100px;min-width:100px" }
      ];
    },
    title() {
      return this.selectedCar.title
    },
    selectedCar() {
      return this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`] || {};
    },
    computedFields() {
      let arr = []
      if(this.selectedCar && this.selectedCar.comments && this.selectedCar.comments.length > 0){
        const comments = _.orderBy(this.selectedCar.comments,"created_at",'desc')
        console.log("this.selectedCar.comments",comments)
        for(let i =0; i < comments.length;i++){
          arr.push({
            carName: this.selectedCar.title,
            comment: comments[i].comment,
            rawComment: comments[i].comment,
            sender: comments[i].user.username,
            commentId: comments[i].id,
            carId: this.selectedCar.id,
            isEdit: false
          })
        }
      }
      return arr
    }
  },

  methods: {
    onEditClose(item){
      console.log("onEditClose", item)
      item.comment = item.rawComment;
      this.onEditItem(item)
    },
    async onEditSubmit(item){
      item.rawComment = item.comment
      debugger
      this[commentsStore.actionTypes.ACTION_EDIT_COMMENT]({
          carId: item.carId,
          id: item.commentId,
          comment: item.comment
        })

      // await api.put(`/comment/admin/${item.carId}/${item.commentId}/edit?comment=${item.comment}`);
      this.onEditItem(item)
      await this[auctionManagerStore.actionTypes.ACTION_PAGE_REOLAD](true)
    },
    onInputEdit(item, e){
    },
    onEditItem(item) {
      let findIndex = this.selectedCar.comments.findIndex(x => x.id === item.commentId)
      if(findIndex > -1){
        item.isEdit = !item.isEdit;
        this.selectedCar.comments[findIndex].isEdit = item.isEdit
      }
      // this.$modals.open(ModalType.EditCarModal, item);
    },
    onDeleteItem(item) {
      console.log("onDeleteItem", item)
      const deleteAction = async () => {
        try {
          this.$modals.close(ModalType.ConfirmationModal);
          await api.delete(`/statistical/comment/${item.commentId}`);
          this.$router.go();
        } catch (error) {
          console.log(error);
        }
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: `Are you sure you want to delete this comment?`,
        buttonText: "Delete",
        onClickButton: deleteAction
      });
    },
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    }
  }
};
</script>
<style>
.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
}
</style>